import { useMemo } from "react";
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Filler, Title, Tooltip, Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Title, Tooltip, Legend);

const MONTHS_FULL  = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const MONTHS_SHORT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

export function OrdersChart({ orders, height = "250px" }) {
  const currentYear = new Date().getFullYear();

  const { paidByMonth, openByMonth } = useMemo(() => {
    const paid = new Array(12).fill(0);
    const open = new Array(12).fill(0);
    orders.forEach(o => {
      const d = new Date(o.created_at);
      if (d.getFullYear() !== currentYear) return;
      const m = d.getMonth();
      if (o.paid) paid[m] += parseFloat(o.amount) || 0;
      else open[m] += parseFloat(o.amount) || 0;
    });
    return { paidByMonth: paid, openByMonth: open };
  }, [orders, currentYear]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: ctx => ` ${ctx.dataset.label}: ${parseFloat(ctx.raw).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`,
        },
      },
    },
    scales: {
      x: { grid: { color: "rgba(0,0,0,.04)" }, ticks: { font: { size: 10 }, color: "#a0aec0" } },
      y: {
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: {
          font: { size: 10 }, color: "#a0aec0",
          callback: v => `R$${(v / 1000).toFixed(0)}k`,
        },
        beginAtZero: true,
      },
    },
  };

  const data = {
    labels: MONTHS_SHORT,
    datasets: [
      {
        label: "Pagos",
        data: paidByMonth,
        borderColor: "#004a33",
        backgroundColor: "rgba(0,74,51,.1)",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
      {
        label: "Em aberto",
        data: openByMonth,
        borderColor: "#fc8f04",
        backgroundColor: "rgba(252,143,4,.1)",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
    ],
  };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Line options={options} data={data} />
    </div>
  );
}
